import Layers from "slotworks/graphics/layers/layers";
import AbstractStepperControl from "slotworks/smart-ui/controls/abstract/abstract-stepper-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { formatMoneyAsCurrency } from "slotworks/utils/string-formatters";
import BetModel from "slotworks/model/bets/bet-model";

export default class CreditSizeStepperControl extends AbstractStepperControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.stepperComponent.formatFunction = formatMoneyAsCurrency;
        this.stepperComponent.onUpdate.add(this.onStepperUpdated);
        this.setEnabled(true);
    }

    public updateOptions(options: ControlOptions) {
        if (!this.setupData) {
            this.setupValues(options.creditSizes.values, options.creditSizes.currentValue);
            this.setupData = true;
        } else {
            this.setSelectedValue(options.creditSizes.currentValue);
        }
    }

    private onStepperUpdated = (value: number) => {
        const options = new ControlOptions();
        options.creditSizes.currentValue = value;

        this.onChange.dispatch(options);
    }
    public setEnabled(enabled: boolean) {
        super.setEnabled(enabled);

        // Never enable stepper during free bets
        if (BetModel.freeBet) {
            this.stepperComponent.setEnabled(false);
        }
    }
}
